import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { screeningAction } from '../../actions/constant';
import screeningService from '../../../services/apiServices/screeningDetails/screeningDetails';

const { GET_DISCIPLINE_TYPE_REQUEST, GET_DISCIPLINE_TYPE_SUCCESS, GET_DISCIPLINE_TYPE_FAILURE } =
  screeningAction;

function* getDisciplineType(payload: any): SagaReturnType<any> {
  try {
    const response = yield call(screeningService.getDisciplineType, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_DISCIPLINE_TYPE_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_DISCIPLINE_TYPE_FAILURE, payload: error });
  }
}

function* getDisciplineTypeSaga() {
  yield takeEvery(GET_DISCIPLINE_TYPE_REQUEST, getDisciplineType);
}

export default getDisciplineTypeSaga;
